/** Textes « aide » — le français fait foi. */
export const aide = {
  titre: (poste: string) => `Guide ${poste.toLowerCase()}`,
  sousTitre: (pour: string) => `Comment se servir du logiciel à votre poste — ${pour}`,
  imprimer: 'Imprimer ce guide',
  leVotre: ' · le vôtre',
  aRetenir: 'À retenir',
};
